import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './core/layout/not-found/not-found.component';
import { NoRightsComponent } from './core/layout/no-rights/no-rights.component';
import { IsSignedInGuard } from './core/authentication/login/is-sign-in.guard';
import { SidenavComponent } from './core/layout/sidenav/sidenav.component';
import { UserRight } from './core/authentication/login/user.model';
import { HasRightsGuard } from './core/authentication/has-rights/has-rights.guard';

const routes: Routes = [
  {
    path: '',
    component: SidenavComponent,
    canActivate: [IsSignedInGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboards',
        pathMatch: 'full',
      },
      {
        path: 'dashboards',
        title: $localize`Dashboards`,
        loadChildren: (): any => import('./dashboard/dashboard.module'),
      },
      {
        path: 'scoring',
        title: $localize`Scoring`,
        loadChildren: (): any => import('./scoring/scoring.module'),
      },
      {
        path: 'monitoring',
        title: $localize`Monitoring`,
        loadChildren: (): any => import('./monitoring/monitoring.module'),
      },
      {
        path: 'traffic',
        title: $localize`Traffic`,
        loadChildren: (): any => import('./traffic/traffic.module'),
      },
      {
        path: 'measures',
        title: $localize`Explore`,
        loadChildren: (): any => import('./explore/explore.module'),
      },
      {
        path: 'events',
        title: $localize`Events`,
        loadChildren: (): any => import('./events/events.module'),
      },
      {
        path: 'settings',
        title: $localize`Settings`,
        loadChildren: (): any => import('./settings/settings.module'),
      },
      {
        path: 'keys',
        title: $localize`Api keys`,
        loadChildren: (): any => import('./api-keys/api-keys.module'),
      },
      {
        path: 'preferences',
        title: $localize`User preferences`,
        loadChildren: (): any => import('./user-preferences/user-preferences.module'),
      },
      {
        path: 'status',
        loadChildren: (): any => import('./status/status.module'),
        data: { rights: [UserRight.SUPER_USER] },
        canActivate: [HasRightsGuard],
      },
      { path: 'no-rights', component: NoRightsComponent, data: { displayed: false } },
      { path: '**', component: NotFoundComponent, data: { displayed: false } },
    ],
  },
  { path: 'login', loadChildren: (): any => import('./core/authentication/authentication.module') },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
